import createReactClass from "create-react-class";
import moment from "moment";
import momentTz from "moment-timezone";
import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import _ from "underscore";
import { PrintSchematicActions } from "../actions/printSchematicActions";
import { SchematicAPI } from "../actions/schematicAPI";
import { ServerActions } from "../actions/serverActions";
import { SubdivisionActions } from "../actions/subdivisionActions";
import { TerritoryActions } from "../actions/territoryActions";
import { ConfirmationModalActions } from "../actions/submissionConfirmationModalActions";
import { TabActions } from "../actions/tabActions";
import { WsActions } from "../actions/wsActions";
import { InformationRadiatorView } from "../components/informationRadiator";
import { FormCFormView } from "../components/issuedFormC";
import { OverrideUserDisplayView } from "../components/overrideUserDisplay";
import { RestrictionList } from "../components/restrictionList";
import { FormBFormView } from "../components/restrictionRequestForm";
import { SchematicToolBar } from "../components/schematicToolbar";
import { TCMFormView } from "../components/tcm";
import Constants from "../constants/constants";
import { informationRadiatorStore } from "../stores/informationRadiator";
import { restrictionRequestStore } from "../stores/restrictionRequest";
import { schematicToolbarStore } from "../stores/schematicToolbar";
import { subdivisionStore } from "../stores/subdivision";
import { tabsStore } from "../stores/tabs";
import { territoryStore } from "../stores/territory";
import { userStore } from "../stores/user";
import { getQryValue } from "../util/helper";
import { BatchButton } from "./batchButtons";
import { pollStore } from '../stores/poll';
import { withRouter } from "../util/withRouter";
import VoidedDialogView from "./voidedModal";

import "../css/adminScreen.css";

var TYPES = Constants.RestrictionTypes;

function getStateFromStores() {
  return {
    collapsed: tabsStore.isCollapsed(),
    tabIndex: tabsStore.getTabIndex(),
    aRequestList: filterARequests(tabsStore.aRequestList()),
    bRequestList: filterBRequests(tabsStore.bRequestList()),
    aIssuedList: tabsStore.aIssuedList(),
    bIssuedList: tabsStore.bIssuedList(),
    cIssuedList: tabsStore.cIssuedList(),
    tcmIssuedList: tabsStore.tcmIssuedList(),
    recentList: tabsStore.recentIssuedList(),
    recentListLoading: tabsStore.recentListLoading(),
    requestListLoading: tabsStore.requestListLoading(),
    issuedListLoading: tabsStore.issuedListLoading(),
    restrictionLoading: tabsStore.restrictionLoading(),
    batchMode: tabsStore.inBatchMode(),
    selectedList: tabsStore.selectedList(),
    currentBatch: tabsStore.currentBatch(),
    canBatchSubmit: tabsStore.canBatchSubmit(),
    batchType: tabsStore.batchType(),
    formType: tabsStore.getFormType(),
    storeState: tabsStore.stateDescription(),
    allowableBatchTypes: tabsStore.allowableBatchTypes(),
    selectedBatchType: tabsStore.selectedBatchType(),
    batchForms: tabsStore.batchForms(),
    reasonList: tabsStore.reasonList(),
    openVoidedDialog: tabsStore.openVoidedDialog(),

    messages: informationRadiatorStore.getMessages(),

    user: userStore.getSelectedRole(),
    printLata: userStore.getLata(),
    userInitials: userStore.getUser(),

    subdivision: subdivisionStore.getSelectedSub(),
    ptcSubs: subdivisionStore.getPtcSubdivisionList(),
    subSelected: subdivisionStore.isSubSelected(),
    subsForTerritory: subdivisionStore.getSubList(),

    isModifying: restrictionRequestStore.isModifying(),
    isReadOnly: restrictionRequestStore.getReadOnly(),
    isDirty: restrictionRequestStore.isDirty(),
    canSubmit: restrictionRequestStore.canSubmit(),
    controlNumber: restrictionRequestStore.getControlNumber(),
    form: restrictionRequestStore.getForm(),

    autoCenterAndZoom: schematicToolbarStore.canAutoCenterAndZoom(),
    showFieldEntryTab: tabsStore.showFormCEntryTab(),
    schematicLoaded: restrictionRequestStore.isSchematicLoaded(),
    isBlocking: pollStore.isBlocking(),
  };
}

const TabsViewComponent = createReactClass({
  componentDidMount: function () {
    tabsStore.subscribe(this._onChange);
    restrictionRequestStore.subscribe(this._onChange);
    subdivisionStore.subscribe(this._onChange);
    territoryStore.subscribe(this._onChange);
    schematicToolbarStore.subscribe(this._onChange);
    PrintSchematicActions.initialize();
    SchematicAPI.initialize();
    ServerActions.startOutageStateCheck();
    ServerActions.getReasonList("B");
    ServerActions.getReasonList("A");
    ServerActions.getReasonList("AReject");
    ServerActions.getReasonList("BReject");
    WsActions.initialize();

    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
    if (!String.prototype.startsWith) {
      Object.defineProperty(String.prototype, "startsWith", {
        value: function (search, rawPos) {
          var pos = rawPos > 0 ? rawPos | 0 : 0;
          return this.substring(pos, pos + search.length) === search;
        },
      });
    }

    this.interval = setInterval(() => {
      if (this.state.subSelected) {
        if (!(this.state.isModifying || this.state.isDirty)) {
          // if ((typeof this.activeForm !== 'undefined') && (typeof
          // this.eventKey !== 'undefined')) {
          if (
            typeof window.searchSortActive !== "undefined" &&
            window.searchSortActive
          ) {
            // No-op
          } else {
            TabActions.backgroundReload();
            this.handleTabColor();
          }
          // }
        }
      }
    }, 180000);

    //Handle special URLs
    if (window.location && window.location.pathname === "/restriction") {
      //Open a restriction form
      const controlNumber = Number(getQryValue("number"));
      const subdivision = getQryValue("subdivision");
      this.props.navigate("/"); //This clears the parameters from the URL by placing a "/" in history
      this.openRestrictionSub(controlNumber, subdivision);
    }

    if (window.location && window.location.pathname === "/request") {
      //Open a restriction form
      const syncId = Number(getQryValue("syncId"));
      const subdivision = getQryValue("subdivision");
      const type = getQryValue("type");
      const dsJobId = getQryValue("dsJobId");
      this.props.navigate("/"); //This clears the parameters from the URL by placing a "/" in history
      this.openRequestSub(syncId, subdivision, type, dsJobId);
    }
  },

  componentDidUpdate: function () {
    this.handleTabColor();
  },

  componentWillUnmount: function () {
    tabsStore.unsubscribe(this._onChange);
    restrictionRequestStore.unsubscribe(this._onChange);
    subdivisionStore.unsubscribe(this._onChange);
    territoryStore.unsubscribe(this._onChange);
    schematicToolbarStore.unsubscribe(this._onChange);
    clearInterval(this.interval);
  },

  getInitialState: function () {
    return getStateFromStores();
  },

  _onChange: function () {
    this.setState(getStateFromStores());
  },

  handleTabColor: function () {
    var index = this.state.tabIndex.form;

    const fourteenHoursFromNow = moment().add(14, "h");

    // Show A Tab as red if there are a requests
    if (this.state.aRequestList.length > 0) {
      if (index === 1) {
        $("a#formTabs-tab-1").removeClass("tabColorChange");
        $("a#formTabs-tab-1").addClass("tabSelectedColorChange");
      } else {
        $("a#formTabs-tab-1").removeClass("tabSelectedColorChange");
        $("a#formTabs-tab-1").addClass("tabColorChange");
      }
    } else {
      $("a#formTabs-tab-1").removeClass("tabColorChange");
      $("a#formTabs-tab-1").removeClass("tabSelectedColorChange");
    }

    const unselectedUrgentClass = "tabColorChange";
    const selectedUrgentClass = "tabSelectedColorChange";
    const unselectedNormalClass = "tabColorRequestChange";
    const selectedNormalClass = "tabSelectedColorRequestChange";

    // Show B Tab as red if there are b requests
    if (this.state.bRequestList.length > 0) {
      // Check if there is a request with a start datetime sooner than 14
      // hours
      let urgentRequest = _.find(this.state.bRequestList, function (req) {
        let startDateTimeTZ = moment.tz(
          req.workStartDate,
          Constants.Timezones[req.restrictionTimeZone]
        );
        return startDateTimeTZ.isBefore(fourteenHoursFromNow);
      });

      // If there is a request less than 14 hours away from start the tab
      // is red, else green
      if (index === 2) {
        if (urgentRequest !== undefined) {
          $("a#formTabs-tab-2").removeClass(unselectedUrgentClass);
          $("a#formTabs-tab-2").removeClass(unselectedNormalClass);
          $("a#formTabs-tab-2").removeClass(selectedNormalClass);
          $("a#formTabs-tab-2").addClass(selectedUrgentClass);
        } else {
          $("a#formTabs-tab-2").removeClass(unselectedNormalClass);
          $("a#formTabs-tab-2").removeClass(unselectedUrgentClass);
          $("a#formTabs-tab-2").removeClass(selectedUrgentClass);
          $("a#formTabs-tab-2").addClass(selectedNormalClass);
        }
      } else {
        if (urgentRequest !== undefined) {
          $("a#formTabs-tab-2").removeClass(selectedUrgentClass);
          $("a#formTabs-tab-2").removeClass(unselectedNormalClass);
          $("a#formTabs-tab-2").removeClass(selectedNormalClass);
          $("a#formTabs-tab-2").addClass(unselectedUrgentClass);
        } else {
          $("a#formTabs-tab-2").removeClass(selectedNormalClass);
          $("a#formTabs-tab-2").removeClass(unselectedUrgentClass);
          $("a#formTabs-tab-2").removeClass(selectedUrgentClass);
          $("a#formTabs-tab-2").addClass(unselectedNormalClass);
        }
      }
    } else {
      $("a#formTabs-tab-2").removeClass(unselectedUrgentClass);
      $("a#formTabs-tab-2").removeClass(selectedUrgentClass);
      $("a#formTabs-tab-2").removeClass(unselectedNormalClass);
      $("a#formTabs-tab-2").removeClass(selectedNormalClass);
    }
  },

  onVoidedDialogClose: function () {
    TabActions.closeVoidedModal();
    this.props.navigate("/");
  },

  onClickShowHide: function () {
    TabActions.toggleCollapse(!this.state.collapsed);
  },

  onCenterZoomCheckChanged: function (e) {
    TabActions.centerZoomCheckChanged(e.target.checked);
  },

  handleFormSelect: function (key) {
    var k = key;
    this.eventKey = key;
    if (this.state.isDirty) {
      window
        .confirm("Confirm Tab Change", {
          description:
            "Changing tabs will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "Change Tab",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(k, "form");
          SchematicAPI.resetSchematicNoPrompt();
        });
    } else {
      if (
        ((this.state.formType === "B" && key === 2) ||
          (this.state.formType === "A" && key === 1)) &&
        (this.state.isModifying || this.state.isReadOnly)
      ) {
        return;
      } else {
        TabActions.changeTab(key, "form");
        SchematicAPI.resetSchematicNoPrompt();
      }
    }
  },

  handleASelect: function (key) {
    this.activeForm = "a";
    this.eventKey = key;
    // Clear search field
    $(".searchId").each(function (item, elem) {
      $(elem).val("");
    });

    if (this.state.isDirty) {
      window
        .confirm("Confirm Tab Change", {
          description:
            "Changing tabs will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "Change Tab",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(key, "a");
        });
    } else {
      if (key === 3 && (this.state.isModifying || this.state.isReadOnly)) {
        return;
      }
      TabActions.changeTab(key, "a");
    }
  },

  handleBSelect: function (key) {
    this.activeForm = "b";
    this.eventKey = key;
    // Clear search field
    $(".searchId").each(function (item, elem) {
      $(elem).val("");
    });

    if (this.state.isDirty) {
      window
        .confirm("Confirm Tab Change", {
          description:
            "Changing tabs will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "Change Tab",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(key, "b");
        });
    } else {
      if (key === 3 && (this.state.isModifying || this.state.isReadOnly)) {
        return;
      }
      TabActions.changeTab(key, "b");
    }
  },

  handleCSelect: function (key) {
    this.activeForm = "c";
    this.eventKey = key;
    // Clear search field
    $(".searchId").each(function (item, elem) {
      $(elem).val("");
    });

    if (this.state.isDirty) {
      window
        .confirm("Confirm Tab Change", {
          description:
            "Changing tabs will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "Change Tab",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(key, "c");
        });
    } else {
      /*
       * if(key===4 && (this.state.isModifying || this.state.isReadOnly)){
       * return; }
       */
      TabActions.changeTab(key, "c");
    }
  },
  handleTCMSelect: function (key) {
    this.activeForm = "tcm";
    this.eventKey = key;
    // Clear search field
    $(".searchId").each(function (item, elem) {
      $(elem).val("");
    });

    if (this.state.isDirty) {
      window
        .confirm("Confirm Tab Change", {
          description:
            "Changing tabs will abandon all of your current work. Are you sure you want to do this?",
          confirmLabel: "Change Tab",
          abortLabel: "Go Back",
        })
        .then(function () {
          TabActions.changeTab(key, "tcm");
        });
    } else {
      if (key === 3 && (this.state.isModifying || this.state.isReadOnly)) {
        return;
      }
      TabActions.changeTab(key, "tcm");
    }
  },

  batchModeOn: function () {
    TabActions.setBatchMode(true);
  },

  batchModeOff: function () {
    TabActions.setBatchMode(false);
  },

  nextBatch: function () {
    this.changeBatch(this.state.currentBatch + 1, false);
  },

  previousBatch: function () {
    this.changeBatch(this.state.currentBatch - 1, false);
  },

  changeBatch: function (index, validationOnly) {
    if (
      [
        Constants.BatchTypes.ISSUE,
        Constants.BatchTypes.MODIFY,
        Constants.BatchTypes.APPROVE,
      ].indexOf(this.state.batchType) > -1
    ) {
      if (this.state.canSubmit) {
        var clearForm =
          this.state.batchType === Constants.BatchTypes.ISSUE &&
          index >= this.state.batchForms.length &&
          !validationOnly;
        ServerActions.validateForm(
          restrictionRequestStore.getForm(),
          index,
          this.state.batchType,
          validationOnly,
          clearForm,
          this.state.batchForms[index]
        );
      } else {
        window.alert(
          "Errors were found on this request. Please fix all errors before moving on."
        );
        ConfirmationModalActions.validateBeforeSubmitting();
      }
    } else {
      ServerActions.validateForm(
        restrictionRequestStore.getForm(),
        index,
        this.state.batchType,
        validationOnly,
        false,
        this.state.batchForms[index]
      );
    }
  },

  submitBatch: function () {
    ServerActions.submitBatchForms(
      this.state.batchForms,
      this.state.batchType,
      this.state.printLata,
      this.state.reasonList
    );
  },

  validateBatch: function () {
    this.changeBatch(this.state.currentBatch, true);
  },

  startBatch: function () {
    TabActions.startBatch(
      this.state.selectedBatchType,
      this.state.selectedList
    );
  },

  addRestriction: function () {
    this.changeBatch(this.state.currentBatch + 1, false);
  },

  onBatchTypeSelectChange: function (event) {
    TabActions.selectBatchType(event.target.value);
  },

  openRestrictionSub: function (controlNumber, subdivision) {

    SubdivisionActions.selectChanged(subdivision);
    ServerActions.openRestrictionByControlNumberSubdivision(
      controlNumber,
      subdivision
    );
  },

  openRequestSub: function (syncId, subdivision, type, dsJobId) {
    SubdivisionActions.selectChanged(subdivision);
    console.log("subdivision", subdivision);
   console.log("dsJobId", dsJobId);
   console.log("type", type);
    if (type === "modify") {
      ServerActions.openRequestToModifyBySyncIdSubdivision(syncId, subdivision);
    } else {
      if (type === "voided") {
        ServerActions.openRequestBySyncIdSubdivision(syncId, subdivision, 'voided', dsJobId);
      }else{
        ServerActions.openRequestBySyncIdSubdivision(syncId, subdivision,'');
      }
    }
  },

  getQryValueFromProps: function (path) {
    if (!path || !this.props.location.search) return "";
    const qry = new URLSearchParams(this.props.location.search);
    return qry.get(path) || "";
  },

  // modify this to return the formBform view markup
  render: function () {
    var userInitialsMod = "";
    let ptcRsIndicator = "";

    //TODO fix Global Directory
    // if (this.state.userInitials !== undefined) {
    //   if (this.state.user.indexOf(Constants.Roles.FIELD_USER) >= 0) {
    //   } else if (
    //     this.state.userInitials.initials == null ||
    //     this.state.userInitials.initials === " " ||
    //     this.state.userInitials.initials === ""
    //   ) {
    //     userInitialsMod = (
    //       <div id="userInitialsDiv">
    //         <UserInitialsView />
    //       </div>
    //     );
    //   }
    // }

    let buttonsShown = "";
    let div = $("#tabControlOuterDiv");

    if (
      this.state.storeState === "issuedFormA" ||
      this.state.storeState === "issuedFormB" ||
      this.state.storeState === "requestFormA" ||
      this.state.storeState === "requestsFormB" ||
      this.state.storeState === "entryFormC" ||
      this.state.storeState === "issuedFormC" ||
      this.state.storeState === "entryFormTCM" ||
      this.state.storeState === "issuedFormTCM" ||
      this.state.storeState === "recentTab"
    ) {
      let parentHeight = $("#divContainer").outerHeight();
      let issuedHeight = parentHeight * 0.945;

      if (screen.height <= 768) {
        issuedHeight = parentHeight * 0.9;
      }
      issuedHeight = issuedHeight.toFixed(0);
      div.animate({ height: Math.max(issuedHeight, 300) + "px" });
      buttonsShown = "none";
    } else {
      div.animate({ height: "300px" });
    }

    // calc glyph
    let glyphClass = "glyphicon glyphicon-triangle-bottom";
    if (this.state.collapsed) {
      glyphClass = "glyphicon glyphicon-triangle-top";
    }

    // calc show/hide style of controls
    let tabsShown = "";
    let collapsed = "shown";
    let infoRad = "infoRadShown";
    if (this.state.collapsed) {
      tabsShown = "none";
      collapsed = "collapsed";
      infoRad = "infoRadCollapsed";
    }

    const style = {
      fontWeight: "bold",
      marginLeft: "10px",
      marginTop: "10px",
      fontSize: "x-large",
    };

    /**
     * Since we are reusing the form component, we only load the form that
     * is on the selected tab. this way the ids on the form are unique in
     * the dom
     */
    let formAForm = <div></div>;
    let formBForm = <div></div>;
    let formCForm = <div></div>;
    let tcmForm = <div></div>;
    let formATitle = "Form A";
    let formBTitle = "Form B";
    let formCTitle = "Form C";
    let tcmTitle = "TCM";
    let recentTitle = Constants.recentHours + " HR";

    let bRequestList = <div style={style}>Please select a subdivision</div>;
    let bIssuedList = <div style={style}>Please select a subdivision</div>;

    let aIssuedList = <div style={style}>Please select a subdivision</div>;
    let aRequestList = <div style={style}>Please select a subdivision</div>;

    let cIssuedList = <div style={style}>Please select a subdivision</div>;
    let tcmIssuedList = <div style={style}>Please select a subdivision</div>;
    let recentIssuedList = <div style={style}>Please select a subdivision</div>;


    if (this.state.subSelected) {
      if (
        this.state.ptcSubs !== null &&
        this.state.ptcSubs !== undefined &&
        this.state.ptcSubs.indexOf(this.state.subdivision) >= 0
      ) {
        ptcRsIndicator = (
          <div id="ptcIndicatorDiv">
            <span>PTC RS SUB</span>
          </div>
        );
      }
      formATitle = formATitle + "-" + this.state.subdivision;
      formBTitle = formBTitle + "-" + this.state.subdivision;
      formCTitle = formCTitle + "-" + this.state.subdivision;
      tcmTitle = tcmTitle + "-" + this.state.subdivision;
      recentTitle = recentTitle + "-" + this.state.subdivision;

      bRequestList = (
        <RestrictionList
          data={this.state.bRequestList}
          loading={this.state.requestListLoading}
          batchMode={this.state.batchMode}
          isDirty={this.state.isDirty}
          selectedSub={this.state.subdivision}
          gridType={"requestFormB"}
          messages={this.state.messages}
          userRoles={this.state.user}
          ref="requestGrid"
        />
      );
      bIssuedList = (
        <RestrictionList
          data={this.state.bIssuedList}
          idProperty="requestId"
          loading={this.state.issuedListLoading}
          isDirty={this.state.isDirty}
          selectedSub={this.state.subdivision}
          batchMode={this.state.batchMode}
          gridType={"issuedFormB"}
          messages={this.state.messages}
          ref="issuedGrid"
        />
      );
      aIssuedList = (
        <RestrictionList
          data={this.state.aIssuedList}
          loading={this.state.issuedListLoading}
          selectedSub={this.state.subdivision}
          isDirty={this.state.isDirty}
          batchMode={this.state.batchMode}
          gridType={"issuedFormA"}
          messages={this.state.messages}
          ref="issuedGrid"
        />
      );
      aRequestList = (
        <RestrictionList
          data={this.state.aRequestList}
          loading={this.state.requestListLoading}
          selectedSub={this.state.subdivision}
          isDirty={this.state.isDirty}
          batchMode={this.state.batchMode}
          gridType={"requestFormA"}
          messages={this.state.messages}
          userRoles={this.state.user}
          ref="requestGrid"
        />
      );
      cIssuedList = (
        <RestrictionList
          data={this.state.cIssuedList}
          loading={this.state.issuedListLoading}
          selectedSub={this.state.subdivision}
          isDirty={this.state.isDirty}
          batchMode={this.state.batchMode}
          gridType={"issuedFormC"}
          messages={this.state.messages}
          ref="issuedGrid"
        />
      );

      tcmIssuedList = (
        <RestrictionList
          data={this.state.tcmIssuedList}
          loading={this.state.issuedListLoading}
          selectedSub={this.state.subdivision}
          isDirty={this.state.isDirty}
          batchMode={this.state.batchMode}
          gridType={"issuedTCM"}
          messages={this.state.messages}
          ref="issuedGrid"
        />
      );

      recentIssuedList = (
        <RestrictionList
          data={this.state.recentList}
          loading={this.state.recentListLoading}
          selectedSub={this.state.subdivision}
          isDirty={this.state.isDirty}
          batchMode={this.state.batchMode}
          gridType={"recentIssued"}
          messages={this.state.messages}
          ref="issuedGrid"
        />
      );
      this.handleTabColor();
    }

    switch (this.state.tabIndex["form"]) {
      case 1: // Form A tab
        formAForm = <FormBFormView type={TYPES.A} user={this.props.user} />;
        break;

      case 2: // Form B tab
        formBForm = <FormBFormView type={TYPES.B} user={this.props.user} />;
        break;

      case 4: // Form C tab
        formCForm = <FormCFormView user={this.props.user} />;
        break;
      case 5: // tcm tab
        tcmForm = <TCMFormView user={this.props.user} />;
        break;
      default:
      // no op
    }

    // Hide the From C entry tab if this is a field user who is not
    // modifying
    let formCEntryTab = "";
    let tcmEntryTab = "";
    const notFieldUser =
      this.state.user.indexOf(Constants.Roles.FIELD_USER) < 0;
    if (notFieldUser || this.state.showFieldEntryTab) {
      formCEntryTab = (
        <Tab eventKey={2} title={entryTitle.bind(this)()}>
          {formCForm}
        </Tab>
      );

      tcmEntryTab = (
        <Tab eventKey={2} title={entryTitle.bind(this)()}>
          {tcmForm}
        </Tab>
      );
    }

    let recentTab = "";
    if (
      notFieldUser &&
      this.state.user.indexOf(Constants.Roles.READ_ONLY) !== 0
    ) {
      //Only show the recent tab to dispatcher or higher access
      recentTab = (
        <Tab eventKey={6} title={recentTitle}>
          <Tabs
            defaultActiveKey={this.state.tabIndex["recent"]}
            activeKey={this.state.tabIndex["recent"]}
            id="recentTabs"
          >
            <Tab eventKey={1} title={issuedTitle.bind(this)()}>
              {recentIssuedList}
            </Tab>
          </Tabs>
        </Tab>
      );
    }

    // build up the form and bind the values
    return (
      <div>
        <div id="informationRadiatorOuterDiv" className={infoRad}>
          <InformationRadiatorView />
        </div>
        <div id="autoCenterAndZoomDiv" className={collapsed}>
          <input
            type="checkbox"
            checked={this.state.autoCenterAndZoom}
            onChange={this.onCenterZoomCheckChanged}
            name="centerAndZoomCheckBox"
            id="centerAndZoomCheckBox"
          />
          Automatically center and zoom schematic on selection
        </div>
        <div id="userInitialsDiv">{userInitialsMod}</div>
        <div id="overrideIndicatorDiv">
          <OverrideUserDisplayView />
        </div>
        {ptcRsIndicator}
        <div id="schematicToolbar" className={collapsed}>
          <SchematicToolBar />
        </div>
        <div
          id="divDataTableShowHideContainer"
          className={collapsed}
          onClick={this.onClickShowHide}
        >
          <span className={glyphClass}></span>
        </div>
        <div
          id="tabControlOuterDiv"
          className="visible"
          style={{ display: tabsShown }}
        >
          <Tabs
            defaultActiveKey={this.state.tabIndex["form"]}
            activeKey={this.state.tabIndex["form"]}
            onSelect={this.handleFormSelect}
            id="formTabs"
          >
            <Tab eventKey={1} title={formATitle}>
              <Tabs
                defaultActiveKey={this.state.tabIndex["a"]}
                activeKey={this.state.tabIndex["a"]}
                onSelect={this.handleASelect}
                id="aTabs"
              >
                <Tab eventKey={1} title={issuedTitle.bind(this)()}>
                  {aIssuedList}
                </Tab>
                <Tab eventKey={2} title={requestTitle.bind(this)()}>
                  {aRequestList}
                </Tab>
                <Tab eventKey={3} title={entryTitle.bind(this)()}>
                  {formAForm}
                </Tab>
              </Tabs>
            </Tab>
            <Tab eventKey={2} title={formBTitle}>
              <Tabs
                defaultActiveKey={this.state.tabIndex["b"]}
                activeKey={this.state.tabIndex["b"]}
                onSelect={this.handleBSelect}
                id="bTabs"
              >
                <Tab eventKey={1} title={issuedTitle.bind(this)()}>
                  {bIssuedList}
                </Tab>
                <Tab eventKey={2} title={requestTitle.bind(this)()}>
                  <div id="testDiv">{bRequestList}</div>
                </Tab>
                <Tab eventKey={3} title={entryTitle.bind(this)()}>
                  {formBForm}
                </Tab>
              </Tabs>
            </Tab>
            <Tab eventKey={4} title={formCTitle}>
              <Tabs
                defaultActiveKey={this.state.tabIndex["c"]}
                activeKey={this.state.tabIndex["c"]}
                onSelect={this.handleCSelect}
                id="cTabs"
              >
                <Tab eventKey={1} title={issuedTitle.bind(this)()}>
                  {cIssuedList}
                </Tab>

                {formCEntryTab}
              </Tabs>
            </Tab>

            <Tab eventKey={5} title={tcmTitle}>
              <Tabs
                defaultActiveKey={this.state.tabIndex["tcm"]}
                activeKey={this.state.tabIndex["tcm"]}
                onSelect={this.handleTCMSelect}
                id="tcmTabs"
              >
                <Tab eventKey={1} title={issuedTitle.bind(this)()}>
                  {tcmIssuedList}
                </Tab>
                {tcmEntryTab}
              </Tabs>
            </Tab>
            {recentTab}
          </Tabs>
          <div
            id="buttonsDiv"
            className="visible"
            style={{ display: buttonsShown }}
          >
            <BatchButton />
          </div>
        </div>
        {this.state.openVoidedDialog && (
          <VoidedDialogView
            restriction={this.state.form}
            onClose={this.onVoidedDialogClose}
          />
        )}
      </div>
    );
  },
});

export const TabsView = withRouter(TabsViewComponent);

function filterBRequests(requestData) {
  var modifiedData = [];
  if (
    userStore.getSelectedRole()[0] === Constants.Roles.DISPATCHER &&
    requestData
  ) {
    const currentTerritory = territoryStore.getSelectedTerritory();
    let twentyFourHoursFromNow = moment().add(24, "h");
    for (var i = 0; i < requestData.length; i++) {
      let item = requestData[i];
      let startDateTimeTZ = moment.tz(
        item.workStartDate,
        Constants.Timezones[item.restrictionTimeZone]
      );
      //Only show requests that are less than 24 hours from now
      if (startDateTimeTZ.isBefore(twentyFourHoursFromNow)) {
        for (let j = 0; j < item.dispatchers.length; j++) {
          let disp = item.dispatchers[j];
          if (disp.dispatcherId.trim() === currentTerritory) {
            if (disp.statusCode === "O") {
              modifiedData.push(item); //Show the request if it is the selected DSJob and it is an "O"
            }
          }
        }
      }
    }
  } else {
    modifiedData = requestData;
  }
  return modifiedData;
}

function filterARequests(requestData) {
  var modifiedData = [];

  if (userStore.getSelectedRole()[0] === Constants.Roles.DISPATCHER) {
    const currentTerritory = territoryStore.getSelectedTerritory();
    for (var i = 0; i < requestData.length; i++) {
      var item = requestData[i];
      for (let j = 0; j < item.dispatchers.length; j++) {
        let disp = item.dispatchers[j];
        if (disp.dispatcherId.trim() === currentTerritory) {
          if (disp.statusCode === "O" || disp.statusCode === "A") {
            modifiedData.push(item); //Show the request if it is the selected DSJob and it is an "A" or an "O"
          }
        }
      }
    }
  } else {
    modifiedData = requestData;
  }

  return modifiedData;
}

function requestTitle() {
  if (this.state.formType === "A") {
    return "Requests-Form A";
  } else if (this.state.formType === "B") {
    return "Requests-Form B";
  }
  return "Requests";
}

function issuedTitle() {
  if (this.state.formType === "A") {
    return "Issued-Form A";
  } else if (this.state.formType === "B") {
    return "Issued-Form B";
  } else if (this.state.formType === "C") {
    return "Issued-Form C";
  } else if (this.state.formType === "TCM") {
    return "Issued-TCM";
  } else if (this.state.formType === "RECENT") {
    let now = moment();
    let past = moment().subtract(Constants.recentHours, "h");
    let zoneName = momentTz.tz.guess(); //Get the name of the timezone of the users browser
    var timezone = momentTz.tz(zoneName).zoneAbbr()[0]; //Abbreviate to just the first letter of the zone ex: CST -> C
    return (
      "16 HR Range: " +
      past.format("HH:mm") +
      timezone +
      " - " +
      now.format("HH:mm") +
      timezone
    );
  }
  return "Issued";
}

function entryTitle() {
  var currentRestriction = restrictionRequestStore.getForm();
  if (this.state.isReadOnly) {
    if (
      (this.state.formType === "A" || this.state.formType === "B") &&
      currentRestriction.status === "request"
    ) {
      if (this.state.controlNumber !== 0)
        return (
          "Modify" +
          (this.state.controlNumber
            ? "-{0}".replace("{0}", this.state.controlNumber)
            : "")
        );
      else
        return (
          "Details" +
          (currentRestriction.syncId
            ? "-GR{0}".replace("{0}", currentRestriction.syncId)
            : "")
        );
    } else if (this.state.formType === "C") {
      return (
        "Modify" +
        (currentRestriction.syncId
          ? "-GR{0}".replace("{0}", currentRestriction.syncId)
          : "")
      );
    } else if (this.state.formType === "TCM") {
      return (
        "Modify" +
        (currentRestriction.syncId
          ? "-GR{0}".replace("{0}", currentRestriction.syncId)
          : "")
      );
    } else {
      return (
        "Details" +
        (this.state.controlNumber
          ? "-{0}".replace("{0}", this.state.controlNumber)
          : "")
      );
    }
  } else {
    if (this.state.isModifying) {
      if (this.state.formType === "B") {
        return (
          "Modify" +
          (currentRestriction.syncId
            ? "-GR{0}".replace("{0}", currentRestriction.syncId)
            : "")
        );
      } else if (this.state.formType === "A") {
        if (currentRestriction.status === "request") {
          return (
            "Modify" +
            (currentRestriction.syncId
              ? "-GR{0}".replace("{0}", currentRestriction.syncId)
              : "")
          );
        } else if (currentRestriction.status === "restriction") {
          return (
            "Modify" +
            (this.state.controlNumber
              ? "-{0}".replace("{0}", this.state.controlNumber)
              : "")
          );
        }
      } else if (this.state.formType === "C") {
        return (
          "Modify" +
          (this.state.controlNumber
            ? "-{0}".replace("{0}", this.state.controlNumber)
            : "")
        );
      } else if (this.state.formType === "TCM") {
        return (
          "Modify" +
          (this.state.controlNumber
            ? "-{0}".replace("{0}", this.state.controlNumber)
            : "")
        );
      }
    } else {
      if (this.state.formType === "A") {
        return "Entry-Form A";
      } else if (this.state.formType === "B") {
        return "Entry-Form B";
      } else if (this.state.formType === "C") {
        return "Entry-Form C";
      } else if (this.state.formType === "TCM") {
        return "Entry-TCM";
      }
      return "Entry";
    }
  }
}
